import { isoToUs, usToIso } from './UsDateInput';

/**
 * A FREE-TEXT box with a calendar that fills it with the picked date as `MM/DD/YYYY`.
 *
 * For a column that is a string in G5 but holds dates (Instrument Purchase / Acceptance / Start Date): turning it into
 * a real date field would blank — and on the next save wipe — any value typed in G5 that is not a date ("2019",
 * "Jan 2020"). So the text stays exactly as stored and editable; the calendar only ever writes INTO the box.
 *
 * The calendar is the browser's own date control with its text hidden, so what shows at the box's right edge is the
 * SAME black native calendar icon a plain `<input type="date">` (Retired Date) shows — one look across the form.
 *
 * The value crossing `onChange` is the text itself, as a plain text field would give.
 */
export function DatePickText({ id, className, value, readOnly, maxLength, onChange }: {
  id?: string;
  className?: string;
  /** The stored text, or '' / null when empty. */
  value: string | null | undefined;
  readOnly?: boolean;
  maxLength?: number;
  onChange: (text: string) => void;
}) {
  return (
    <span className="usdate">
      <input
        id={id}
        className={className}
        type="text"
        maxLength={maxLength}
        value={value ?? ''}
        readOnly={readOnly}
        disabled={readOnly}
        onChange={(e) => onChange(e.target.value)}
      />
      {!readOnly && (
        <input
          className="dpt-native"
          type="date"
          tabIndex={-1}
          aria-label="Open date picker"
          title="Open date picker"
          value={usToIso(value)}
          onChange={(e) => { if (e.target.value) onChange(isoToUs(e.target.value)); }}
        />
      )}
    </span>
  );
}
